/*
 * @Author: luting
 * @Date: 2022-04-08 15:14:30
 * @lastEditors: luting
 * @LastEditTime: 2023-07-26 10:28:49
 */
import { defineMessages } from 'react-intl';

const messageObject: { [propName: string]: string } = {
  warnNotice: '告警通知管理',
  noticeSet: '通知设置',
  personSet: '收件人设置',
  ip: '服务器地址',
  port: '端口号',
  senderEmail: '发件人邮箱',
  senderPassword: '发件人密码',
  size: '容量',
  sendTip: '单封邮件附件容量(M),请根据实际邮件服务器支持大小填写',
  sendError: '单封邮件附件容量不能大于2048M',
  testLink: '连接测试',
  linking: '测试中...',
  success: '连接成功',
  fail: '连接失败',
  doing: '正在处理中...',
  placeholder: '请输入',
  update: '编辑',
  updateNoticeSet: '编辑通知设置',
  ok: '确认',
  cancel: '取消',
  ipRules: '服务器地址格式不正确',
  portRules: '端口格式不正确',
  tipRules: '附件容量格式不正确,容量只支持正整数',
  emailRules: '邮箱格式不正确',
  add: '添加',
  sendTestEmal: '发送测试邮件',
  sending: '发送中',
  sendTestEmalConfirm: '请问是否发送测试邮件? ',
  email: '邮箱',
  recipient: '收件人',
  operate: '操作',
  delete: '删除',
  deleteTip: '删除后,收件人将无法收到告警通知,请确认?',
  emailTip: '使用第三方邮箱时,需要在第三方邮箱处开启TOP3/SMTP/IMAP服务',
  recipientList: '测试邮件收件人列表(至少选择一个)',
  recipientNull: '请选择收件人',
  sendSuccessTip: '发送测试邮件成功，请{name}检查邮箱是否收到',
};

export default defineMessages(messageObject);
